// src/App.tsx
import { Routes, Route } from "react-router-dom"; // BrowserRouter is in src/main.tsx
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";

import ChatButton from "@/components/ChatButton";
import NavBar from "@/components/layout/NavBar";

// pages
import HomePage from "@/pages/Home";
import ChartsPage from "@/pages/Charts";
import SimulatorPage from "@/pages/Simulator";
import About from "@/pages/About";
import Auth from "@/pages/Auth";
import NotFound from "@/pages/NotFound";

// auth guard
import RequireAuth from "@/components/auth/RequireAuth";

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        {/* BrowserRouter is mounted in src/main.tsx */}
        <NavBar />
        <main className="mx-auto max-w-6xl px-4 py-6">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/auth" element={<Auth />} />
            <Route
              path="/simulator"
              element={
                <RequireAuth>
                  <SimulatorPage />
                </RequireAuth>
              }
            />
            <Route path="/charts" element={<ChartsPage />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <ChatButton />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
